import Accordion from 'react-bootstrap/Accordion'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/esm/Col'
import Container from 'react-bootstrap/esm/Container'
import Badge from 'react-bootstrap/Badge';
import Image from 'react-bootstrap/Image';
import Table from 'react-bootstrap/Table';

import '../utils/general.css';
import '../utils/experiences.css'

import enTranslations from '../locales/en.json';
import frTranslations from '../locales/fr.json';
import { useLanguage } from '../components/languageContext'; // Importez le hook useLanguage

import MMlogo from '../assets/pictures/mm-logo.png';
import Textmelogo from '../assets/pictures/textme.png';
import Educationlogo from '../assets/pictures/education.png';
import Education from '../assets/pictures/education.jpg';
import Other from '../assets/pictures/other.jpg';

export default function Experiences() {
  const { language } = useLanguage();

  // Importez les traductions en fonction de la langue
  const translations = language === 'en' ? enTranslations : frTranslations;

  return (
    <Container className='ps-experiences vertical-center mb-5' fluid>
      <Row className='ps-row ps-profil-title'>
        <Col>
          <h2 className="text-center mt-5 mb-3 fw-bold">{translations.experience.titre}</h2>
          <Accordion defaultActiveKey="0" className="">
            <Accordion.Item eventKey="0" className="sens-90">
              <Accordion.Header className=''>
                <Row className="" style={{ width: '100vw'}} >
                  <Col xs={10} className='d-flex flex-column '>
                    <h2 className='fw-bold '>
                      {translations.experience.freelance_exp.title}
                    </h2>
                    <p className='fst-italic'>
                      {translations.since}: 2023
                    </p>
                  </Col>
                  <Col xs={2} className='d-none d-sm-flex justify-content-start align-items-center'>
                    <Badge pill bg="success">{translations.in_prog}</Badge>
                  </Col>
                </Row>
              </Accordion.Header>
              <Accordion.Body className='custom-body'>
                <div className='d-flex justify-content-center align-items-center'>
                  <div className='base-cube'>
                    <div className="cube">
                      <div className="face front "></div>
                      <div className="face back "></div>
                      <div className="face left "></div>
                      <div className="face right "></div>
                      <div className="face top "></div>
                      <div className="face bottom "></div>
                    </div>
                  </div>
                </div>
                
                <div className="mt-3">
                  <p className='mb-0 fw-bolder fs-5'>{translations.experience.freelance_exp.exp1}</p>
                  <p className='fw-lighter'>{translations.experience.freelance_exp.exp1_bis}</p>
                  <p className='fw-lighter'>{translations.experience.freelance_exp.exp1_ter}</p>
                </div>
                
                <div className="mt-5">
                  <p className='mb-0 fw-bolder fs-5'>{translations.experience.freelance_exp.exp2}</p>
                  <p className='mb-0'>{translations.experience.freelance_exp.exp2_bis}</p><br />
                  <p className='mb-0 fw-bolder'>{translations.experience.freelance_exp.exp2_bot_1}</p>
                  <p className=''>{translations.experience.freelance_exp.exp2_bot_1_1}</p>


                  <p className='mb-0 fw-bolder'>{translations.experience.freelance_exp.exp2_bot_2}</p>
                  <p className=''>{translations.experience.freelance_exp.exp2_bot_2_1}</p>

                  <p className='mb-0 fw-bolder'>{translations.experience.freelance_exp.exp2_bot_3}</p>
                  <p className=''>{translations.experience.freelance_exp.exp2_bot_3_1}</p>
                </div>

                <div className="mt-5">
                  <p className='mb-0 fw-bolder fs-5'>{translations.experience.freelance_exp.exp3}</p>
                  <p className='fw-lighter'>{translations.experience.freelance_exp.exp3_1}</p>

                  <p className='mb-0 fw-bolder'>{translations.experience.freelance_exp.exp3_2_1}</p>
                  <p className=''>{translations.experience.freelance_exp.exp3_2_2}</p>

                  <p className='mb-0 fw-bolder'>{translations.experience.freelance_exp.exp3_3_1}</p>
                  <p className=''>{translations.experience.freelance_exp.exp3_3_2}</p>

                  <p className='mb-0 fw-bolder'>{translations.experience.freelance_exp.exp3_4_1}</p>
                  <p className=''>{translations.experience.freelance_exp.exp3_4_2}</p>

                  <p className='fw-lighter'>{translations.experience.freelance_exp.exp_end}</p>
                </div>

                
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1" className="sens-80">
              <Accordion.Header>
                <Row style={{ width: '100vw'}} >
                  <Col xs={10} className='d-flex flex-column '>
                    <h2 className='fw-bold '>
                      {translations.experience.mm.title}
                    </h2>
                    <p className='fst-italic'>
                      {translations.since}: 2023
                    </p>
                  </Col>
                  <Col xs={2} className='d-none d-sm-flex justify-content-start align-items-center'>
                    <Badge pill bg="success">{translations.in_prog}</Badge>
                  </Col>
                </Row>
              </Accordion.Header>
              <Accordion.Body className='custom-body'>
                <Image
                  src={MMlogo}
                  fluid
                  className='rounded mx-auto d-block img-thumbnail mb-4'
                />
                <div className='ps-experience-list-title'>
                  <b>{translations.experience.mm.exp1}</b><br />
                  {translations.experience.mm.exp2}<br />
                  {translations.experience.mm.exp3}
                  </div>  
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2" className="sens-70">
              <Accordion.Header>
                <Row style={{ width: '100vw'}} >
                  <Col xs={10} className='d-flex flex-column '>
                    <h2 className='fw-bold '>
                      {translations.experience.intership.title}
                    </h2>
                    <p className='fst-italic'>
                    {translations.during}: 6 {translations.month}s
                    </p>
                  </Col>
                  <Col xs={2} className='d-none d-sm-flex justify-content-start align-items-center'>
                    <Badge pill bg="primary">{translations.done}</Badge>
                  </Col>
                </Row>
              </Accordion.Header>
              <Accordion.Body className='custom-body'>
                <Image
                  src={Textmelogo}
                  fluid
                  className='rounded mx-auto d-block img-thumbnail mb-4'
                />
                <div className='ps-experience-list-title'>
                  <b>{translations.experience.intership.info}</b><br />
                  {translations.experience.intership.exp1}<br />
                  {translations.experience.intership.exp2}<br />
                  {translations.experience.intership.exp3}<br />
                  {translations.experience.intership.exp4}
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3" className="sens-60">
              <Accordion.Header>
                <Row style={{ width: '100vw'}} >
                  <Col xs={10} className='d-flex flex-column '>
                    <h2 className='fw-bold '>
                      {translations.experience.teacher.title}
                    </h2>
                    <p className='fst-italic'>
                      {translations.during}: 2 {translations.year}s
                    </p>
                  </Col>
                  <Col xs={2} className='d-none d-sm-flex justify-content-start align-items-center'>
                    <Badge pill bg="primary">{translations.done}</Badge>
                  </Col>
                </Row>
              </Accordion.Header>
              <Accordion.Body className='custom-body'>
                <Image
                  src={Educationlogo}
                  fluid
                  className='rounded mx-auto d-block img-thumbnail mb-4'
                />
                <div className='ps-experience-list-title'>
                  <b>{translations.experience.teacher.info}</b><br />
                  {translations.experience.teacher.exp1}<br />
                  {translations.experience.teacher.exp2}<br />
                  {translations.experience.teacher.exp3}<br />
                  {translations.experience.teacher.exp4}
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4" className="sens-50">
              <Accordion.Header>
                <Row style={{ width: '100vw'}} >
                  <Col xs={10} className='d-flex flex-column '>
                    <h2 className='fw-bold '>
                      {translations.experience.edu_various.title}
                    </h2>
                    <p className='fst-italic'>
                      {translations.during}: 6 {translations.year}s
                    </p>
                  </Col>
                  <Col xs={2} className='d-none d-sm-flex justify-content-start align-items-center'>
                    <Badge pill bg="primary">{translations.done}</Badge>
                  </Col>
                </Row>
              </Accordion.Header>
              <Accordion.Body className='custom-body'>
                <Image
                  src={Education}
                  fluid
                  className='rounded mx-auto d-block my-2 img-thumbnail'
                  alt="Picture by Kimberly Farmer"
                  title="Picture by Kimberly Farmer"
                /> 
                <Table striped bordered hover className="table-info" variant="dark">
                  <thead>
                    <tr className='text-lg-start text-center fs-4'>
                      <th>{translations.title}</th>
                      <th>{translations.time_spend}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{translations.experience.edu_various.exp1}</td>
                      <td>{translations.experience.edu_various.exp1_time} {translations.month}s</td>
                    </tr>
                    <tr>
                      <td>{translations.experience.edu_various.exp2}</td>
                      <td>{translations.experience.edu_various.exp2_time} {translations.month}s</td>
                    </tr>
                    <tr>
                      <td>{translations.experience.edu_various.exp3}</td>
                      <td>{translations.experience.edu_various.exp3_time} {translations.year}s</td>
                    </tr>
                    <tr>
                      <td>{translations.experience.edu_various.exp4}</td>
                      <td>{translations.experience.edu_various.exp4_time} {translations.year}s</td>
                    </tr>
                  </tbody>
                </Table>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5" className="sens-40">
              <Accordion.Header>
                <Row style={{ width: '100vw'}} >
                  <Col xs={10} className='d-flex flex-column '>
                    <h2 className='fw-bold '>
                      {translations.experience.various.title}
                    </h2>
                    <p className='fst-italic'>
                      {translations.during}: 4 {translations.year}s
                    </p>
                  </Col>
                  <Col xs={2} className='d-none d-sm-flex justify-content-start align-items-center'>
                    <Badge pill bg="primary">{translations.done}</Badge>
                  </Col>
                </Row>
              </Accordion.Header>
              <Accordion.Body className='custom-body'>
                <Image
                  src={Other}
                  fluid
                  className='rounded mx-auto d-block my-2 img-thumbnail'
                  alt="Picture by Moren Hsu"
                  title="Picture by Moren Hsu"
                /> 
                <Table striped bordered hover className="table-secondary" variant="dark">
                  <thead>
                    <tr className='text-lg-start text-center fs-4'>
                      <th>{translations.title}</th>
                      <th>{translations.time_spend}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{translations.experience.various.exp1}</td>
                      <td>{translations.experience.various.exp1_time} {translations.month}s</td>
                    </tr>
                    <tr>
                      <td>{translations.experience.various.exp2}</td>
                      <td>{translations.experience.various.exp2_time} {translations.month}s</td>
                    </tr>
                    <tr>
                      <td>{translations.experience.various.exp3}</td>
                      <td>{translations.experience.various.exp3_time} {translations.year}s</td>
                    </tr>
                    <tr>
                      <td>{translations.experience.various.exp4}</td>
                      <td>{translations.experience.various.exp4_time} {translations.month}s</td>
                    </tr>
                  </tbody>
                </Table>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        
        </Col>
      </Row>

    </Container>
  )
}